




import { Component, Mixins, Prop } from "vue-property-decorator";
import { BrowserUtility, AsyncUtility } from "../../../utilities";
import { Document } from "../../../domain/document";
import {
  IHisInformationApplicable,
  instanceOfIHisInformationApplicable,
} from "../../../domain/document/items";
import { DocumentMerger } from "../helpers";
import {
  EditingDocument,
} from "../editor/EditingDocument";

@Component
export default class DocumentProcessor extends Mixins() {
  @Prop()
  process: (source: Document) => Promise<any>;  // 返却する型は利用側で変えられるように.

  @Prop()
  emptyHisKeys: string[];

  async processDocument<T>(document: Document): Promise<T> {
    await this._initializeDocument(document);
    return this._processDocument<T>(document);
  }

  async processQuotedDocument<T>(document: Document, quoteDocument: Document): Promise<T> {
    await this._initializeDocument(document);
    try {
      await this._mergeDocuments(document, await this._initializeDocumentToQuote(quoteDocument));
    } catch (e) {
      this.$error("エラー", e.message, e);
    }
    return this._processDocument<T>(document);
  }

  private async _initializeDocument(document: Document): Promise<void> {
    const editingDocument = new EditingDocument(document);
    try {
      await editingDocument.initialize(); // 計算式の更新等初期化する.
      this.emptyHisInformation(editingDocument);
    } catch (e) {
      this.$error("エラー", e.message, e);
    }
  }

  private async _processDocument<T>(document: Document): Promise<T> {
    return (await this.process(document)) as T;
  }

  private async _initializeDocumentToQuote(document: Document): Promise<Document> {
    this.$logger.info("引用・転記元の文書を初期化します。");
    const editingDocument = new EditingDocument(document);
    // 値を取得する文書の計算式を走らせる必要あるのかどうか・・？
    // 不要な気がしないでもない
    try {
      await editingDocument.initialize(); // 計算式の更新等初期化する.
    } catch (e) {
      this.$error("エラー", e.message, e);
    }
    return document;
  }

  private async _mergeDocuments(document: Document, valueSourceDocument: Document): Promise<Document> {
    const merger = new DocumentMerger(document);
    const isByName = !merger.isSameFormat(valueSourceDocument);
    merger.mergeDocument(valueSourceDocument, isByName);
    await merger.copyImagesFromDocumentAsync();
    if (BrowserUtility.isChromiumBrowser()) {
      if (merger.source.externalScriptRunner.hasRequestedScripts) {
        if (!this.$configuration.behavior.localhost.internalScript.isEnable) {
          // ChromeはUrlSchemeを叩く間隔が短いと対象のEXEを起動できない現象が発生する。
          // 3.5秒程度の間隔を空けると起動できる模様なので、無理やり間隔を空けている。
          this.$logger.debug("ChromeのUrlScheme対策でsleepします。");
          await AsyncUtility.sleep(4000);
          this.$logger.debug("ChromeのUrlScheme対策でsleepしました。");
        }
      }
    }
    await merger.executeScriptInDocumentAtCalculateAsync(this.$configuration.behavior.document.editor.externalScript.shouldExecuteAsStackedRequest);
    const isSuccess = await merger.executeStackedScriptsAsyncWithResult();
    if (!isSuccess) {
      this.$error("外部スクリプト", "外部スクリプトの実行中にエラーが発生しています。");
    }
    return merger.sourceAsDocument;
  }

  private emptyHisInformation(document: EditingDocument): void {
    if (!this.emptyHisKeys || (this.emptyHisKeys.length <= 0)) {
      return;
    }
    for (let itemSetId = 0; itemSetId < document.itemSets.length; itemSetId++) {
      const itemSet = document.itemSets[itemSetId];
      for (const item of itemSet.items) {
        if (!instanceOfIHisInformationApplicable(item)) { continue; }
        if (item.hisItemParameter && this.emptyHisKeys.indexOf(item.hisItemParameter.key) > -1) {
          const cloned = item.clone() as IHisInformationApplicable;
          cloned.setHisInfoItems(null, false); // rollbackValue()でも問題ないと思われるが、入力を切り替えたかった(v1相当)ため。
          document.updateItem(cloned, {
            itemSetId,
          });
        }
      }
    }
  }
}
